export default {
  // Header Section
  "discover_your": "உங்கள்",
  "sadesati": "சார்டே சதி (SadeSati)",
  "saturn_influence_analysis": "சனி தாக்கம் பகுப்பாய்வு",
  "sadesati_description": "உங்கள் வாழ்க்கையில் சனியின் தாக்கத்தை விரிவாக அறிந்து, சவால்களை வளர்ச்சி மற்றும் வெற்றிக்கான வாய்ப்புகளாக மாற்ற உதவும் நுண்ணறிவுகளும் பரிகாரங்களும் பெறுங்கள்.",

  "sadesati_your": "SadeSati பகுப்பாய்வு",

  // Service Information
  "enter_details_for_sadesati": "SadeSati பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_sadesati_analysis": "முழுமையான SadeSati பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_sadesati_analysis_note": "சனியின் கோச்சாரத் தாக்கங்களின் ஆழமான பகுப்பாய்வு மற்றும் தனிப்பயன் பரிகார வழிகாட்டுதல்",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_saturn_influence": "உங்கள் பெயர் அதிர்வுகள், சனி ஆற்றல் முறைபாடுகளுடன் ஒத்திசைவு பெறலாம்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_moon_position": "உங்கள் சந்திர ராசி மற்றும் SadeSati நிலையைக் கணக்கிட இது அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_sadesati": "சந்திர ராசியைத் துல்லியமாக கணக்கிட சரியான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_essential_for_sadesati": "இட அளவுகள் கிரக கணக்கீடுகளை பாதிக்கும்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் SadeSati பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core SadeSati Features
  "sadesati_phase_identification": "SadeSati நிலை அடையாளம்",
  "saturn_effects_analysis": "சனி தாக்கம் — பகுப்பாய்வு",
  "remedies_and_solutions": "பரிகாரங்கள் & தீர்வுகள்",
  "timeline_predictions": "காலவரிசை முன்கணிப்புகள்",
  "life_guidance_during_sadesati": "SadeSati கால வாழ்க்கை வழிகாட்டுதல்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் SadeSati பகுப்பாய்வில் உள்ளவை",
  "complete_sadesati_timeline": "முழு SadeSati காலவரிசை",
  "saturn_influence_analysis_item": "சனி தாக்கம் பகுப்பாய்வு",
  "personalized_remedies": "தனிப்பயன் பரிகாரங்கள்",
  "life_guidance_insights": "வாழ்க்கை வழிகாட்டுதல் & நுண்ணறிவுகள்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் SadeSati பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "sadesati_analysis_processing": "உங்கள் SadeSati பகுப்பாய்வை எங்கள் வேத ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். உங்கள் வாழ்க்கையில் சனியின் தற்போதைய தாக்கம் குறித்த விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான SadeSati அறிக்கை 12 மணிநேரத்தில் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் SadeSati பகுப்பாய்வு தொகுப்பு",
  "detailed_sadesati_report": "முழுமையான SadeSati அறிக்கை (PDF)",
  "saturn_phase_analysis": "சனி நிலை & காலவரிசை பகுப்பாய்வு",
  "remedial_measures_guidance": "பரிகார வழிமுறைகள் & வழிகாட்டுதல்",
  "life_predictions_timeline": "வாழ்க்கை முன்கணிப்புகள் & காலவரிசை",
  "spiritual_guidance_saturn": "சனி கால ஆன்மீக வழிகாட்டுதல்",

  // Visual Content
  "sample_sadesati_analysis": "மாதிரி SadeSati பகுப்பாய்வு",
  "sadesati_phase": "SadeSati நிலை",
  "sample_sadesati_description": "தற்போது உச்சநிலை — சனி தாக்கம் மிகுதியாக இருக்கும் காலம்",
  "sample_sadesati_preview": "நிலை விவரங்களுடன் உங்கள் தனிப்பயன் SadeSati பகுப்பாய்வின் முன்னோட்டம்",
  "sadesati_phases": "SadeSati நிலைகள்",

  // SadeSati Phase Types
  "rising_phase": "உயரும் நிலை (Entering)",
  "peak_phase": "உச்ச நிலை (Peak)",
  "setting_phase": "இறங்கும் நிலை (Exiting)",

  // Status & Processing
  "your_sadesati_analysis_status": "உங்கள் SadeSati பகுப்பாய்வு நிலை",
  "processing_your_analysis": "சனியின் தாக்கம் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் வாழ்க்கைப் பாதையில் சனியின் தற்போதைய நிலையும் அதன் தாக்கங்களும் ஆய்வு செய்யப்படுகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "ஜோதிட ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // SadeSati-Specific Elements
  "saturn_transit": "சனி கோச்சாரம்",
  "moon_sign": "சந்திர ராசி (ராசி)",
  "saturn_position": "சனியின் தற்போதைய நிலை",
  "sadesati_duration": "SadeSati காலநீளம்",
  "phase_timeline": "நிலை காலவரிசை",
  "saturn_effects": "சனியின் தாக்கங்கள்",

  // Phase Analysis
  "first_phase": "முதல் நிலை (2.5 ஆண்டுகள்)",
  "second_phase": "இரண்டாம் நிலை (2.5 ஆண்டுகள்)",
  "third_phase": "மூன்றாம் நிலை (2.5 ஆண்டுகள்)",
  "phase_characteristics": "நிலை பண்புகள்",
  "phase_challenges": "நிலை சவால்கள்",
  "phase_opportunities": "நிலை வாய்ப்புகள்",

  // Effects & Influences
  "career_effects": "தொழில் & பணிமுறை தாக்கங்கள்",
  "health_effects": "ஆரோக்கியம் & நலன் தாக்கங்கள்",
  "relationship_effects": "உறவு தாக்கங்கள்",
  "financial_effects": "நிதி தாக்கம்",
  "mental_effects": "மன & உணர்ச்சி தாக்கங்கள்",
  "spiritual_effects": "ஆன்மீக வளர்ச்சி தாக்கங்கள்",

  // Remedies & Solutions
  "saturn_remedies": "சனி பரிகாரங்கள்",
  "gemstone_recommendations": "ரத்தின பரிந்துரைகள்",
  "mantra_chanting": "மந்திர ஜபம்",
  "fasting_recommendations": "நோன்பு வழிமுறைகள்",
  "charity_suggestions": "தான தர்ம பரிந்துரைகள்",
  "worship_rituals": "வழிபாட்டு முறைகள்",
  "lifestyle_changes": "வாழ்க்கைமுறை மாற்றங்கள்",

  // Timeline & Predictions
  "current_phase": "தற்போதைய நிலை",
  "remaining_duration": "மீதமுள்ள காலம்",
  "next_phase_start": "அடுத்த நிலை தொடங்கும் தேதி",
  "sadesati_end_date": "SadeSati முடியும் தேதி",
  "monthly_predictions": "மாதாந்திர முன்கணிப்புகள்",
  "yearly_overview": "ஆண்டு மேலோட்டம்",

  // Detailed Analysis Sections
  "saturn_mythology": "வேத புராணங்களில் சனி",
  "karmic_lessons": "கர்மப் பாடங்கள்",
  "past_life_karma": "முன் பிறவி கர்மா",
  "spiritual_significance": "ஆன்மீக முக்கியத்துவம்",
  "growth_opportunities": "வளர்ச்சி வாய்ப்புகள்",
  "life_lessons": "சனியிடமிருந்து வாழ்க்கைப் பாடங்கள்",

  // Practical Guidance
  "do_and_dont": "SadeSati காலத்தில் செய்யவேண்டியது & தவிர்க்க வேண்டியது",
  "precautions": "எடுக்க வேண்டிய முன்னெச்சரிக்கைகள்",
  "best_practices": "சிறந்த நடைமுறைகள்",
  "meditation_practices": "தியானப் பயிற்சிகள்",
  "yoga_recommendations": "யோகா பரிந்துரைகள்",
  "dietary_guidelines": "உணவு வழிகாட்டுதல்கள்",

  // Support & Guidance
  "coping_strategies": "எதிர்கொள்ளும் உத்திகள்",
  "stress_management": "மனஅழுத்த மேலாண்மை",
  "emotional_support": "உணர்ச்சி ஆதரவு முறைகள்",
  "family_guidance": "குடும்ப உறவு வழிகாட்டுதல்",
  "professional_guidance": "தொழில்வாழ்க்கை வழிகாட்டுதல்",

  // Advanced Analysis
  "saturn_aspects": "சனியின் பார்வைகள்",
  "planetary_combinations": "கிரகக் கூட்டிணைப்புகள்",
  "dasha_analysis": "தசா காலப் பகுப்பாய்வு",
  "transit_effects": "கோச்சார தாக்கங்கள்",
  "yogas_formed": "சனியுடன் உருவாகும் யோகங்கள்"
};
